import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Typography } from "@mui/material"
import { IconSeeker, ImageSeeker } from "@ui-seeker/core"

import { LinkIconBlock } from "@components"
import { BACKEND_APIS, DEVICE_TYPE } from "@constants"
import { extraColumnInfo, imageModal, titleModal } from "@signals"
import { ellipsisLined } from "@utils"


export default function imageBannerColumn() {
    return {
        name: '',
        label: 'Image Banner',
        options: {
            filter: false,
            setCellHeaderProps: () => ({
                sx: { minWidth: 150 }
            }),
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: (value, row) => {
                const handleClick = () =>
                    batch(() => {
                        imageModal.value = `${BACKEND_APIS.BANNERS}/image/${row.sovResourceID}`
                        titleModal.value = row.resourceType
                        extraColumnInfo.value = !!row.resourceText ? <Box>{row.resourceText}</Box> : null
                    })

                return <Box sx={{pl: 2, pr: 2}}>
                    <Box sx={{ display: 'flex', justifyContent: 'center'}}>
                        <Box sx={{width: '50px', textAlign: 'center'}}>{row.resourceType}</Box>
                        <Box sx={{width: '120px'}}>&nbsp;</Box>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'column'}}>
                        <Box sx={{display: 'flex', cursor: 'pointer', justifyContent: 'center'}} onClick={handleClick}>
                            <Box sx={{width: '50px'}}>
                                <ImageSeeker
                                    sx={{ height: 50, width: 50 }}
                                    src={`${BACKEND_APIS.BANNERS}/image/${row.sovResourceID}`}
                                />
                            </Box>
                            <Box sx={{width: '120px', textAlign: "left", pl: 2}}>
                                <Box sx={{...ellipsisLined({lines: 2, maxWidth: 200}), fontSize: '0.8rem'}}>{row.resourceText}</Box>
                            </Box>
                        </Box>
                        <Typography variant="subtitle2" gutterBottom >
                            <LinkIconBlock sx={{display: 'inline-block', pr: 1}} url={row.sectionURL}><IconSeeker icon='location-dot' sx={{ ml: 0.5 }} /> {row.sectionName}</LinkIconBlock>
                            { row.deviceID !== DEVICE_TYPE.APP && <LinkIconBlock sx={{display: 'inline-block', pr: 1}} url={row.sourceURL}><IconSeeker icon='globe' sx={{ ml: 0.5 }} /> Source</LinkIconBlock>}
                        </Typography>
                    </Box></Box>
            }
        }
    }
}